import React from 'react';
import { ReactComponent as SoundCloudCoverImage } from 'resources/images/soundcloud-solid.svg';
import { ReactComponent as TuneCoreCoverImage } from 'resources/images/tunecore-solid.svg';
import { ReactComponent as LabelCoverImage } from 'resources/images/songs-solid.svg';
import { ReactComponent as ConnexCoverImage } from 'resources/images/connex-solid.svg';
import { ReleaseType } from 'types/releases';
import { Center } from '@chakra-ui/react';

type Size = 'tiny' | 'small' | 'big';

enum CoverSize {
  tiny = '32px',
  small = '40px',
  big = '128px',
}

const CoverImage = {
  [ReleaseType.SOUNDCLOUD]: <SoundCloudCoverImage />,
  [ReleaseType.TUNECORE]: <TuneCoreCoverImage />,
  [ReleaseType.LABEL]: <LabelCoverImage />,
  [ReleaseType.LABEL_V2]: <ConnexCoverImage />,
};

export interface ReleaseCoverProps {
  type: ReleaseType;
  size: Size;
}

export const ReleaseCover: React.FC<ReleaseCoverProps> = ({ size, type }) => (
  <Center
    width={CoverSize[size]}
    height={CoverSize[size]}
    minWidth={CoverSize[size]}
    minHeight={CoverSize[size]}
    p={size === 'big' ? 6 : '7.5px'}
    flexDirection="column"
    rounded={size === 'big' ? 4 : 2}
    bg="surface2"
    color="M.70"
    overflow="hidden"
    sx={{
      svg: {
        width: '100%',
        height: '100%',
      },
    }}
  >
    {CoverImage[type]}
  </Center>
);
